///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { DataService } from './data.service';
import { DataServiceConfig } from './data-service-config';

export abstract class DataServiceFactory {
    public abstract getService<T>(config: DataServiceConfig): DataService<T>;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/core/data/data-service-factory.ts